import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import articlesData from './articlesData';

const Article = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const article = articlesData.find((article) => article.id === parseInt(id, 10));

  if (!article) {
    return <div>Article not found</div>;
  }

  const siteUrl = `https://intlmarketingchamp.com/article/${article.id}`;

  const seoTitle = article.seoTitle || article.title;
  const seoDescription = article.seoDescription || article.previewText || article.title;
  const seoKeywords = article.seoKeywords || `${article.title}, ${article.autor}`;
  const canonical = article.canonical || siteUrl;

  const ogTitle = article.ogTitle || seoTitle;
  const ogDescription = article.ogDescription || seoDescription;
  const ogImage = article.ogImage || article.image;

  const twitterTitle = article.twitterTitle || seoTitle;
  const twitterDescription = article.twitterDescription || seoDescription;
  const twitterImage = article.twitterImage || ogImage;

  const structuredData =
    article.structuredData || {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: article.title,
      description: seoDescription,
      author: {
        '@type': 'Person',
        name: article.autor,
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': canonical,
      },
      ...(article.image ? { image: [article.image] } : {}),
    };

  const renderContent = (content) => {
    return content.map((block, index) => {
      switch (block.type) {
        case 'paragraph':
          return (
            <p key={index} className="news__detail-text mb-20">
              {block.text}
            </p>
          );

        case 'header':
          return (
            <h5 key={index} className="section__subtitle marg-40">
              {block.text}
            </h5>
          );

        case 'sub-header':
          return (
            <div key={index} className="yellow-text">
              {block.text}
            </div>
          );

        case 'image':
          return (
            <img
              key={index}
              src={block.src}
              alt={block.alt || article.title}
              className="article-page-image"
            />
          );

        case 'list':
          return (
            <ul key={index} className="page-about__text mb-20">
              <li className="page-about__list-item">{block.text}</li>
            </ul>
          );

        default:
          return null;
      }
    });
  };

  return (
    <>
      <Helmet>
        <html lang="ru" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <link rel="canonical" href={canonical} />
        <meta name="robots" content="index,follow,max-image-preview:large" />

        <meta property="og:type" content="article" />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:url" content={canonical} />
        {ogImage && <meta property="og:image" content={ogImage} />}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={twitterTitle} />
        <meta name="twitter:description" content={twitterDescription} />
        {twitterImage && <meta name="twitter:image" content={twitterImage} />}

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div className="section page__wrapper">
        <div className="article-page">
          <h1 className="section__title d-flex">
            <span className="news__detail-title-text">{article.title}</span>
            <span className="news__item-date news__detail-date">
              <span className="news__item-day color-white">{article.date1}</span>
              {article.date2}
            </span>
          </h1>

          <hr className="news__detail-title-hr" />

          <img
            src={article.image}
            alt={article.imageAlt || article.title}
            className="article-page-image"
          />

          <div className="article-page-content">
            {renderContent(article.content)}
          </div>

          <div className="news__detail-text">
            Автор: <span className="link _white">{article.autor}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Article;